function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#BDEDF8;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#66CEEF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M888.59,653.89l-73.2-42.4v41.8c0,2.2-1.2,4.2-3.2,5.4l-116.4,67.2c0,0,0,0-0.2,0.2l-84.4,48.6l-137.8,79.6 c-0.8,0.6-2,0.8-3.2,0.8c-1,0-2.2-0.2-3-0.8l-248.8-143.6c-1.8-1.2-3.2-3.2-3.2-5.4v-58.8l-87.2,50.2l263.4,152.2l79.4,45.8 l284.8-164.2L888.59,653.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M118.99,691.29l3.2,1.8l93.4-53.8v-7.2l-102.6,59.2C114.79,690.29,116.99,690.29,118.99,691.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M894.79,650.29l3-1.8c1.8-1,4.2-1,6,0l-88.4-51v7L894.79,650.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "128.19,696.69 215.39,646.49 215.39,639.29 121.99,693.09 391.59,848.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "888.59,653.89 894.79,650.29 815.39,604.49 815.39,611.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "471.19,894.69 471.19,894.69 755.99,730.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "121.99,719.49 464.99,917.49 464.99,905.29 121.99,707.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M109.79,696.69c0-2.2,1.2-4.2,3.2-5.4C110.99,692.49,109.79,694.49,109.79,696.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M468.2,933.49c-2-1.2-3.2-3.2-3.2-5.2v-3.6l-349-201.6v-19.2l-3.2-1.8c-1.8-1-3.2-3-3.2-5.4v26.4 c0,2.2,1.2,4.2,3.2,5.4L468.2,933.49z"
}), React.createElement("polygon", {
  className: "st1",
  points: "470.99,894.69 471.19,894.69 391.59,848.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M112.79,702.09l3.2,1.8v-7.2l6-3.6l-3.2-1.8c-1.8-1-4.2-1-6,0c-1.8,1.2-3.2,3.2-3.2,5.4 C109.79,698.89,110.99,700.89,112.79,702.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M468.2,896.49l3-1.8l0,0l0,0l-79.4-45.8l-269.6-155.6l-6,3.6L466,899.09 C466.39,897.89,467.19,897.09,468.2,896.49z"
}), React.createElement("polygon", {
  className: "st1",
  points: "121.99,719.49 121.99,707.29 464.99,905.29 464.99,905.29 115.99,703.89 115.99,723.09 464.99,924.69  464.99,917.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M464.99,901.89c0-1,0.4-2.2,0.8-3l-349.8-202.2v7.2l349,201.6V901.89z"
}), React.createElement("polygon", {
  className: "st0",
  points: "894.79,676.69 894.79,664.69 477.39,905.29 477.39,917.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M903.99,659.29l-3,1.6v19.4l-423.6,244.2v3.6c0,2.2-1.2,4.2-3.2,5.2l429.8-247.8c2-1.2,3.2-3.2,3.2-5.4v-26.4 C907.19,656.09,905.99,658.09,903.99,659.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "888.59,653.89 888.59,653.89 755.99,730.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M897.79,648.49l-3,1.8l6.2,3.6v7l3-1.6c2-1.2,3.2-3.2,3.2-5.4s-1.2-4.2-3.2-5.4 C901.99,647.49,899.79,647.49,897.79,648.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M888.59,653.89l-132.8,76.6l-284.8,164.2l3,1.8c1,0.6,1.8,1.4,2.2,2.2l424.6-244.8l-6.2-3.6L888.59,653.89 L888.59,653.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M477.39,928.09v-3.6l-6.2,3.6l-6-3.6v3.6c0,2.2,1.2,4.2,3.2,5.2c0.8,0.6,2,0.8,3,0.8c1,0,2.2-0.2,3.2-0.8 C476.19,932.29,477.39,930.29,477.39,928.09z"
}), React.createElement("path", {
  className: "st1",
  d: "M476.39,898.69c-0.6-1-1.4-1.6-2.2-2.2l-3-1.8l-3,1.8c-1,0.6-1.8,1.4-2.4,2.4l5.2,3L476.39,898.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M470.99,908.09c-1,0-2-0.4-3-0.8l-3.2-1.8l0,0v12.2v7.2l6,3.6v-20.4H470.99z"
}), React.createElement("path", {
  className: "st1",
  d: "M465.79,898.89c-0.6,1-0.8,2-0.8,3v3.6l3.2,1.8c0.8,0.6,2,0.8,3,0.8v-6.2L465.79,898.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "477.39,905.29 894.79,664.69 894.79,676.69 477.39,917.49 477.39,924.49 900.99,680.29 900.99,660.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M477.39,901.89v3.6l423.6-244.4v-7l-424.6,244.6C476.99,899.69,477.39,900.69,477.39,901.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M477.39,905.29L477.39,905.29l-3.2,1.8c-0.8,0.6-1.8,0.8-3.2,0.8v20.2l6.2-3.6v-7L477.39,905.29L477.39,905.29 z"
}), React.createElement("path", {
  className: "st1",
  d: "M477.39,905.29v-3.6c0-1.2-0.4-2.2-0.8-3.2l-5.4,3.2v6.2c1.2,0,2.2-0.4,3.2-0.8L477.39,905.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "221.79,601.49 215.39,597.89 215.39,632.09 221.79,628.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M218.59,710.69l248.8,143.6c-1.8-1.2-3-3.2-3-5.4v-3.6l-242.4-140v-62.4l-6.2,3.6v58.8 C215.39,707.49,216.59,709.49,218.59,710.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "221.79,635.69 221.79,628.49 215.39,632.09 215.39,639.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "221.79,642.89 221.79,635.69 215.39,639.29 215.39,646.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "227.79,605.09 221.79,601.49 221.79,628.49 227.79,625.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "464.19,845.29 464.39,653.49 464.39,653.49 464.19,838.29 227.79,701.69 227.79,639.29 221.79,642.89  221.59,705.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "227.79,625.09 221.79,628.49 221.79,635.69 227.79,632.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "227.79,639.29 227.79,632.09 221.79,635.69 221.79,642.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "809.2,434.09 809.2,593.89 815.39,597.49 815.39,437.69 841.79,422.49 835.59,418.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M581.59,790.89c-1,0-2.2-0.4-3.2-0.8c-1-0.6-1.8-1.4-2.2-2.2l-99.8,57.6v3.6c0,2.2-1.2,4.2-3.2,5.4l137.8-79.6 l-26.6,15.4C583.79,790.49,582.79,790.89,581.59,790.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.79,717.09v3.6c0,2.2-1.2,4.2-3,5.2l116.4-67.2c2-1.2,3.2-3.2,3.2-5.4v-41.8l-6-3.6v45.4L698.79,717.09z"
}), React.createElement("polygon", {
  className: "st1",
  points: "809.2,600.89 815.39,604.49 815.39,597.49 809.2,593.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "815.39,611.49 815.39,604.49 809.2,600.89 809.2,608.09  "
}), React.createElement("path", {
  className: "st1",
  d: "M476.59,848.89v-3.6l-6.2,3.6l-6-3.6v3.6c0,2.2,1.2,4.2,3,5.4c0.8,0.6,2,0.8,3,0.8c1.2,0,2.2-0.2,3.2-0.8 C475.19,853.09,476.59,851.09,476.59,848.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "470.39,642.89 464.39,653.49 464.19,845.29 470.19,848.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M805.99,428.89c-1.8,1-3,3.2-3,5.4v156.2l6.2,3.6v-159.8l26.4-15.2l-6.2-3.6L805.99,428.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M575.39,781.09l-99,57v7l99.8-57.6c-0.6-1-0.8-2-0.8-3V781.09z"
}), React.createElement("polygon", {
  className: "st1",
  points: "698.79,709.89 698.79,717.09 809.2,653.49 809.2,608.09 802.99,604.49 802.99,649.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "802.99,597.29 809.2,600.89 809.2,593.89 802.99,590.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "802.99,604.49 809.2,608.09 809.2,600.89 802.99,597.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "476.59,838.29 476.59,631.89 470.39,642.89 470.19,848.89 476.59,845.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "686.59,521.09 684.79,522.09 686.59,523.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "672.59,529.09 587.79,578.09 587.79,773.89 648.39,739.09 686.59,717.09 686.59,537.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "686.59,523.09 684.79,522.09 678.79,525.69 686.59,530.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "686.59,530.09 678.79,525.69 672.59,529.09 686.59,537.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "686.59,717.09 686.59,717.09 648.39,739.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "695.79,725.89 695.79,725.89 611.19,774.69  "
}), React.createElement("path", {
  className: "st1",
  d: "M692.59,510.49v16.2l6.2,3.6v-19.8c0-2.2-1.2-4.2-3.2-5.4c-2-1.2-4.2-1.2-6,0l-17.2,9.8l6.2,3.6L692.59,510.49 z"
}), React.createElement("path", {
  className: "st1",
  d: "M666.4,525.49l-6.2-3.6l-81.8,47c-2,1-3,3.2-3,5.4v206.8l6.2-3.6v-203L666.4,525.49z"
}), React.createElement("polygon", {
  className: "st1",
  points: "692.59,713.49 698.79,709.89 698.79,544.29 692.59,540.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "692.59,533.49 698.79,537.29 698.79,530.29 692.59,526.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "672.59,522.09 678.59,518.49 672.59,514.89 666.4,518.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "692.59,540.69 698.79,544.29 698.79,537.29 692.59,533.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "666.4,525.49 672.59,522.09 666.4,518.49 660.19,522.09  "
}), React.createElement("path", {
  className: "st1",
  d: "M698.79,720.69v-3.6l-49.4,28.4l-67.8,39.2l0,0l-5.4,3.2c0.6,1,1.4,1.8,2.2,2.2c1,0.6,2.2,0.8,3.2,0.8 s2-0.4,3-0.8l26.6-15.4l84.6-48.8C697.59,724.69,698.79,722.69,698.79,720.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "692.59,720.69 649.39,745.49 698.79,717.09 698.79,709.89 692.59,713.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M575.39,781.09v3.6c0,1.2,0.4,2.2,0.8,3l5.4-3.2v-7L575.39,781.09z"
}), React.createElement("polygon", {
  className: "st1",
  points: "686.59,521.09 686.59,523.09 692.59,526.49 692.59,510.49 678.59,518.49 684.79,522.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "587.79,578.09 672.59,529.09 666.4,525.49 581.59,574.49 581.59,777.49 648.39,739.09 587.79,773.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "686.59,717.09 692.59,713.49 692.59,540.69 686.59,537.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "686.59,530.09 692.59,533.49 692.59,526.49 686.59,523.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "684.79,522.09 678.59,518.49 672.59,522.09 678.79,525.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "672.59,529.09 678.79,525.69 672.59,522.09 666.4,525.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "686.59,537.29 692.59,540.69 692.59,533.49 686.59,530.09  "
}), React.createElement("path", {
  className: "st1",
  d: "M581.59,784.69l67.8-39.2L581.59,784.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "692.59,713.49 686.59,717.09 686.59,717.09 648.39,739.09 581.59,777.49 581.59,784.69 649.39,745.49  692.59,720.69  "
}), React.createElement("polygon", {
  className: "st0",
  points: "278.79,658.89 313.59,678.89 313.59,654.69 278.79,634.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M319.79,687.89c0,0.8-0.6,1.2-1.4,0.8l-44.2-25.4c-0.6-0.4-1.4-1.6-1.4-2.6v-29.6l-6.2-3.6v33.2 c0,3.2,1.8,6.2,4.6,7.8l44,25.4c1,0.6,2.4,0.8,3.8,0.8c1.2,0,2.4-0.2,3.4-0.8c1.8-1.2,3.6-4,3.6-6.2v-26l-6.2-3.6 C319.79,658.09,319.79,687.89,319.79,687.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M313.59,678.89l-34.8-20v-24.2l-6-3.6v29.6c0,1,0.8,2,1.4,2.6l44.2,25.4c0.8,0.4,1.4,0,1.4-0.8v-29.8l-6-3.6 v24.4H313.59z"
}), React.createElement("path", {
  className: "st1",
  d: "M841.79,422.49l11.6,6.8L841.79,422.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M869.39,437.89c0.4,0,0.6,0.2,0.8,0.2c1,0,2-0.2,3-0.8C871.99,437.89,870.79,437.89,869.39,437.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "657.59,316.29 829.39,415.29 829.59,415.29 658.2,315.29  "
}), React.createElement("rect", {
  x: 838.79,
  y: 417.09,
  className: "st1",
  width: 0,
  height: 7.2
}), React.createElement("rect", {
  x: 832.31,
  y: 413.42,
  transform: "matrix(0.4998 -0.8661 0.8661 0.4998 55.1609 929.5618)",
  className: "st1",
  width: 0.2,
  height: 7.2
}), React.createElement("path", {
  className: "st0",
  d: "M851.19,413.49v0.2l19,11.2l25.6-14.8l-237.8-138.8l-11.2,19.4l201.4,117.4 C850.19,409.09,851.19,411.29,851.19,413.49z"
}), React.createElement("polygon", {
  className: "st0",
  points: "421.79,683.49 438.39,673.89 454.39,645.89 437.59,655.69  "
}), React.createElement("polygon", {
  className: "st0",
  points: "605.79,363.89 557.39,448.49 565.19,453.09 646.99,310.09 639.2,305.69  "
}), React.createElement("polygon", {
  className: "st0",
  points: "460.79,616.89 468.59,621.29 558.99,463.69 551.19,459.09  "
}), React.createElement("polygon", {
  className: "st0",
  points: "562.19,458.29 565.19,453.09 557.39,448.49 554.2,453.69  "
}), React.createElement("polygon", {
  className: "st0",
  points: "558.99,463.69 562.19,458.29 554.2,453.69 551.19,459.09  "
}), React.createElement("polygon", {
  className: "st0",
  points: "451.19,633.49 458.2,629.49 454.6,627.49  "
}), React.createElement("polygon", {
  className: "st0",
  points: "460.79,616.89 457.59,622.29 464.39,626.09 466.59,624.69 468.59,621.29  "
}), React.createElement("polygon", {
  className: "st0",
  points: "458.2,629.49 464.39,626.09 457.59,622.29 454.6,627.49  "
}), React.createElement("path", {
  className: "st0",
  d: "M557.39,448.49l48.4-84.6L557.39,448.49z"
}), React.createElement("polygon", {
  className: "st0",
  points: "460.59,616.89 550.99,459.09 550.99,459.09  "
}), React.createElement("polygon", {
  className: "st0",
  points: "554.2,453.49 557.39,448.49 557.39,448.49  "
}), React.createElement("polygon", {
  className: "st0",
  points: "551.19,459.09 554.39,453.89 554.39,453.89  "
}), React.createElement("polygon", {
  className: "st0",
  points: "450.99,633.69 454.6,627.49 454.6,627.49  "
}), React.createElement("polygon", {
  className: "st0",
  points: "457.59,622.09 460.79,616.89 460.79,616.89  "
}), React.createElement("polygon", {
  className: "st0",
  points: "454.6,627.69 457.79,622.29 457.79,622.29  "
}), React.createElement("path", {
  className: "st0",
  d: "M658.99,301.49l192.2,112v-0.2c0-2.2-1-4.2-3-5.4l-201.4-117.4l-1.6,3L658.99,301.49z"
}), React.createElement("path", {
  className: "st0",
  d: "M444.99,644.29l-5.2,9.2c-0.4,0.6-1,0.8-1.4,1.2l-0.6,1l16.8-9.6l6.2-10.8L444.99,644.29z"
}), React.createElement("path", {
  className: "st0",
  d: "M438.39,654.49c0.4-0.4,1.2-0.6,1.4-1.2l5.2-9.2l-1.2,0.8L438.39,654.49z"
}), React.createElement("polygon", {
  className: "st0",
  points: "639.2,305.69 639.2,305.69 605.79,363.89  "
}), React.createElement("polygon", {
  className: "st0",
  points: "444.99,644.29 460.59,635.29 462.39,632.09 458.2,629.49 451.19,633.49  "
}), React.createElement("polygon", {
  className: "st0",
  points: "465.39,626.69 466.59,624.69 464.39,626.09  "
}), React.createElement("polygon", {
  className: "st0",
  points: "458.2,629.49 462.39,632.09 465.39,626.69 464.39,626.09  "
}), React.createElement("polygon", {
  className: "st0",
  points: "556.59,448.09 557.39,448.49 605.79,363.89 639.2,305.69 638.59,305.29  "
}), React.createElement("polygon", {
  className: "st0",
  points: "460.79,616.89 551.19,459.09 550.59,458.69 460.19,616.49  "
}), React.createElement("polygon", {
  className: "st0",
  points: "554.2,453.69 557.39,448.49 556.59,448.09 553.59,453.29  "
}), React.createElement("polygon", {
  className: "st0",
  points: "550.59,458.69 551.19,459.09 554.2,453.69 553.59,453.29  "
}), React.createElement("polygon", {
  className: "st0",
  points: "451.19,633.69 454.6,627.49 453.99,627.09 443.79,644.89 444.99,644.29 451.19,633.49  "
}), React.createElement("polygon", {
  className: "st0",
  points: "456.99,621.89 457.59,622.29 460.79,616.89 460.19,616.49  "
}), React.createElement("polygon", {
  className: "st0",
  points: "453.99,627.09 454.6,627.49 457.59,622.29 456.99,621.89  "
}), React.createElement("polygon", {
  className: "st0",
  points: "639.2,305.69 646.99,310.09 649.2,306.29 641.4,301.69  "
}), React.createElement("path", {
  className: "st0",
  d: "M644.59,296.29L644.59,296.29l9,5.2c0.4-0.2,0.4-0.6,0.8-0.6c1.6-0.4,3.4-0.2,4.8,0.6l-13.8-8l-0.4,0.8 C644.59,295.09,644.79,295.69,644.59,296.29z"
}), React.createElement("path", {
  className: "st0",
  d: "M644.59,296.29L644.59,296.29c0.4-0.6,0-1.2,0.2-1.8l-0.8,1.4L644.59,296.29z"
}), React.createElement("polygon", {
  className: "st0",
  points: "639.2,305.69 639.2,305.69 641.4,301.69 649.2,306.29 650.19,304.69 642.39,300.29  "
}), React.createElement("path", {
  className: "st0",
  d: "M642.79,299.29l7.8,4.6l0,0c0.6-1.2,1.8-1.8,3-2.2l-9-5.2L642.79,299.29z"
}), React.createElement("polygon", {
  className: "st0",
  points: "642.19,298.89 642.79,299.29 644.59,296.29 643.99,295.89  "
}), React.createElement("polygon", {
  className: "st0",
  points: "638.59,305.29 639.2,305.69 642.39,300.29 641.59,299.89  "
}), React.createElement("polygon", {
  className: "st0",
  points: "642.39,300.29 650.19,304.69 650.59,303.89 642.79,299.29  "
}), React.createElement("polygon", {
  className: "st0",
  points: "641.59,299.89 642.39,300.29 642.79,299.29 642.19,298.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M853.39,429.29l13.6,8c0.6,0.4,1.4,0.4,2.2,0.6c-0.8-0.2-1.4-0.2-2.2-0.6L853.39,429.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M661.19,265.69L661.19,265.69l247.2,144.2l-33,19c1.2,1.8,1.6,4,0.4,6c-0.6,1-1.4,1.8-2.4,2.2l0,0l38-22 c1.8-1,3-3.2,3-5.4s-1-4.2-3-5.4l-252.4-146.8h-0.2C661.79,259.09,662.79,262.89,661.19,265.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M442.99,678.29l-27.4,15.8l-5.2,9c-0.6,1.2-1.8,2-3.2,2.6c0.2-0.2,0.6-0.2,1-0.2l38-22 c0.8-0.6,1.8-1.4,2.2-2.4l16-27.8v-12.4L442.99,678.29z"
}), React.createElement("rect", {
  x: 464.39,
  y: 641.09,
  className: "st1",
  width: 0,
  height: 12.4
}), React.createElement("polygon", {
  className: "st1",
  points: "575.79,459.09 657.59,316.29 652.39,313.09 570.39,456.09  "
}), React.createElement("path", {
  className: "st1",
  d: "M569.59,469.69l-5.4-3l-90.4,157.8c1.8,1.2,2.8,3,2.8,5v2.4L569.59,469.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "567.39,461.29 572.79,464.29 575.79,459.09 570.39,456.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "569.59,469.69 572.79,464.29 567.39,461.29 564.39,466.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "476.59,629.49 476.59,631.89 476.59,631.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "470.39,630.49 464.39,641.09 464.39,653.49 470.39,642.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M476.59,629.49c0-2-1.2-4-2.8-5l-3.4,6v12.4l6.2-11L476.59,629.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M875.19,428.89l-5,2.8l-22.4-12.8l-6,3.6l11.6,6.8l13.8,8c0.6,0.4,1.4,0.4,2.2,0.6c1.4,0.2,2.6,0,3.8-0.6 c1-0.6,1.8-1.2,2.4-2.2C876.79,432.89,876.4,430.89,875.19,428.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "657.59,316.29 658.2,315.29 829.59,415.29 832.79,413.29 654.59,309.29 652.39,313.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "835.79,418.89 841.79,422.49 847.99,418.89 841.79,415.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "655.39,307.69 654.59,309.29 832.79,413.29 829.59,415.29 835.79,418.89 841.79,415.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M847.99,418.89l22.2,13L847.99,418.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "841.99,415.29 841.79,415.49 847.99,418.89 847.99,418.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "655.39,307.69 841.79,415.49 841.99,415.29 655.99,306.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M646.99,290.69l11.2-19.4l237.8,138.8l-25.6,14.8l-19-11.2l0,0l22.2,13c1,0.6,1.4,1.6,1.8,2.4l33-19 l-247.2-144.2L646.99,290.69L646.99,290.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "454.39,645.89 438.39,673.89 421.79,683.49 437.59,655.69 437.59,655.69 415.59,694.29 442.99,678.29  464.39,641.09 464.39,640.29  "
}), React.createElement("rect", {
  x: 464.39,
  y: 640.29,
  className: "st1",
  width: 0,
  height: 0.8
}), React.createElement("polygon", {
  className: "st1",
  points: "570.39,456.09 652.39,313.09 646.99,310.09 565.19,453.09  "
}), React.createElement("path", {
  className: "st1",
  d: "M558.99,463.69l-90.4,157.8l5,2.8c0.2,0,0.2,0.2,0.2,0.2l90.4-157.8L558.99,463.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "567.39,461.29 570.39,456.09 565.19,453.09 562.19,458.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "558.99,463.69 564.39,466.69 567.39,461.29 562.19,458.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M466.59,624.69l0.8-0.4c0.8-0.6,1.8-0.8,3-0.8c1.2,0,2,0.4,3.2,0.8l-5-2.8L466.59,624.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "645.19,293.49 646.99,290.49 646.99,290.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "851.19,413.69 851.19,413.69 658.99,301.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "438.19,654.69 437.59,655.69 437.59,655.69 438.39,654.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "454.39,645.89 464.39,640.29 464.39,633.09 464.19,633.09 460.59,635.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "464.19,633.09 464.39,633.09 464.39,640.29 464.39,640.29 464.39,641.09 470.39,630.49 470.39,629.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "443.79,644.89 438.19,654.69 438.39,654.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "460.59,635.29 464.19,633.09 462.39,632.09  "
}), React.createElement("path", {
  className: "st1",
  d: "M473.59,624.29c-1-0.6-2-0.8-3.2-0.8c-1.2,0-2.2,0.4-3,0.8l-0.8,0.4l-1.2,2l5,2.8v0.8L473.59,624.29 C473.79,624.49,473.59,624.29,473.59,624.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "464.19,633.09 470.39,629.49 465.39,626.69 462.39,632.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "555.99,447.69 639.39,305.69 639.39,305.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "460.39,616.69 550.19,458.49 550.19,458.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "553.59,453.29 556.59,448.09 556.59,448.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "550.59,458.69 553.59,453.29 553.59,453.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "443.59,644.89 454.19,627.29 454.19,627.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "456.99,621.89 459.99,616.49 459.99,616.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "453.99,627.29 456.99,621.89 456.99,621.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M851.19,413.69c0,2.2-1,4-3,5l-0.2,0.2l22.2,13l5-2.8c-0.6-0.8-1-1.8-1.8-2.4L851.19,413.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "646.99,310.09 652.39,313.09 654.59,309.29 649.2,306.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M654.39,300.89c-0.4,0-0.4,0.4-0.8,0.6l191.6,111.8l-3.4,2l6.2,3.6l0.2-0.2c1.8-1,2.8-3,3-5l-192.2-112.2 C657.59,300.69,655.99,300.49,654.39,300.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "644.79,294.49 645.19,293.49 645.19,293.49 644.79,294.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "644.79,294.49 644.79,294.29 643.79,295.89 643.99,295.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M653.59,301.49c-1.2,0.6-2.4,1.2-3,2.2l0,0l5.2,3l186,108.4l3.4-2L653.59,301.49z"
}), React.createElement("polygon", {
  className: "st1",
  points: "649.2,306.29 654.59,309.29 655.39,307.69 650.19,304.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "642.19,299.09 643.79,296.09 643.79,296.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "638.59,305.09 641.59,299.89 641.59,299.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "650.59,303.89 650.19,304.69 655.39,307.69 655.99,306.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "641.59,299.69 641.99,298.89 641.99,298.89  "
}), React.createElement("polygon", {
  className: "st0",
  points: "344.99,696.89 379.59,716.89 379.59,692.69 344.99,672.69  "
}), React.createElement("path", {
  className: "st1",
  d: "M385.79,725.89c0,0.8-0.8,1.2-1.4,0.8l-44.2-25.4c-0.8-0.4-1.4-1.6-1.4-2.4v-29.6l-6.2-3.6v33.2 c0,3.2,2,6.2,4.6,7.8l44.2,25.4c1,0.6,2.4,0.8,3.6,0.8c1.4,0,2.6-0.2,3.4-0.8c1.8-1.2,3.4-4,3.4-6.2v-26.2l-6-3.6 C385.79,696.09,385.79,725.89,385.79,725.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M379.59,716.89l-34.6-20v-24.2l-6-3.6v29.6c0,1,0.6,2,1.4,2.4l44.2,25.4c0.6,0.4,1.4,0.2,1.4-0.8v-29.6 l-6.2-3.6v24.4H379.59z"
}), React.createElement("path", {
  className: "st2",
  d: "M182.79,512.09c-3-1.6-4-5.4-2.2-8.4l199.8-348.8l-15.8-9.2c-3-1.8-4-5.4-2.4-8.4c1.8-3,5.6-4,8.6-2.2 l16.8,9.8c0.6-0.4,0.8-0.8,1.4-1c1.6-0.4,3.4-0.2,4.8,0.6l242.6,140.2l11.2-19.6l-277.8-160.4l-244.8,426.8l90.6,52.2v-52.6 L182.79,512.09z"
}), React.createElement("path", {
  className: "st2",
  d: "M266.59,602.69v-9.6c0-2.2,1.8-5.2,3.4-6.2c2.2-1.2,4.8-1.2,7.4,0l8.2,4.8l17.6-10.2l-75.2-43.4v52.6 l29.6,17.2L266.59,602.69z"
}), React.createElement("path", {
  className: "st2",
  d: "M315.39,588.69l-17.6,10.2l23.6,13.6c2.6,1.6,4.6,4.6,4.6,7.8v27.2l6.6,3.8v-19.8c0-2.2,1.6-5.2,3.6-6.2 c2.2-1.2,5-1.2,7.2,0.2l44,25.4c2.8,1.6,4.4,4.6,4.4,7.8v27l11,6.4l22.6-39.6L315.39,588.69z"
}), React.createElement("polygon", {
  className: "st2",
  points: "266.59,609.89 266.59,602.69 257.39,607.89 263.59,611.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "309.39,585.09 303.19,581.49 285.59,591.69 291.59,595.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "315.39,588.69 309.39,585.09 291.59,595.29 297.79,598.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "266.59,609.89 263.59,611.49 266.59,613.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "215.59,530.89 215.39,583.69 221.79,587.29 221.79,534.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "221.79,534.49 221.79,587.29 227.79,590.69 227.79,538.09  "
}), React.createElement("path", {
  className: "st2",
  d: "M218.79,480.49c1.8-1,4.2-1,6,0l126.6,73l191.2-110c1-0.6,2-0.8,3-0.8l82.4-143.6l-49.2-28.4l-187.8-109.6 l-196.8,343.4l21.4,12.4v-30.8C215.59,483.69,216.79,481.69,218.79,480.49z"
}), React.createElement("polygon", {
  className: "st2",
  points: "534.2,462.49 363.79,560.89 449.39,610.29 492.19,535.89  "
}), React.createElement("path", {
  className: "st2",
  d: "M540.19,451.89l5.2-9.2c-1,0-2,0.2-3,0.8l-191.2,110.2l6.2,3.6L540.19,451.89z"
}), React.createElement("polygon", {
  className: "st2",
  points: "534.2,462.49 540.19,451.89 357.59,557.29 363.79,560.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "227.99,496.69 227.79,523.89 315.39,574.49 339.19,560.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "443.39,621.09 351.39,567.89 327.79,581.69 431.59,641.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "339.19,560.89 315.39,574.49 321.59,578.09 345.39,564.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "345.39,564.49 321.59,578.09 327.79,581.69 351.39,567.89  "
}), React.createElement("path", {
  className: "st2",
  d: "M345.19,557.29l6.2-3.6l-126.6-73c-2-1.2-4.2-1.2-6,0c-2,1.2-3.2,3.2-3.2,5.4v30.8l6.2,3.6v-34.4 L345.19,557.29z"
}), React.createElement("polygon", {
  className: "st2",
  points: "363.79,560.89 357.59,564.49 446.39,615.69 449.39,610.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "357.59,557.29 351.39,553.69 345.19,557.29 351.39,560.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "357.59,557.29 351.39,560.89 357.59,564.49 363.79,560.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "339.19,560.89 345.19,557.29 221.79,485.89 221.79,520.49 227.79,523.89 227.99,496.69  "
}), React.createElement("polygon", {
  className: "st2",
  points: "357.59,564.49 351.39,567.89 443.39,621.09 446.39,615.69  "
}), React.createElement("polygon", {
  className: "st2",
  points: "345.19,557.29 339.19,560.89 345.39,564.49 351.39,560.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "351.39,560.89 345.39,564.49 351.39,567.89 357.59,564.49  "
}), React.createElement("path", {
  className: "st2",
  d: "M185.59,506.69l200-348.8l-5.4-3.2l-199.8,348.8c-1.8,3-0.8,6.6,2.2,8.4l32.8,19v-7L185.59,506.69z"
}), React.createElement("path", {
  className: "st2",
  d: "M388.79,143.69c-0.6,0.2-0.8,0.8-1.4,1l247,142.6l1.6-3l-242.6-140.2 C392.19,143.49,390.39,143.29,388.79,143.69z"
}), React.createElement("polygon", {
  className: "st2",
  points: "227.79,531.09 227.79,538.09 303.19,581.49 309.19,578.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "428.39,646.89 321.59,585.29 315.39,588.69 425.39,652.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "315.39,581.69 309.19,578.09 303.19,581.49 309.39,585.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "321.59,585.29 315.39,581.69 309.39,585.09 315.39,588.69  "
}), React.createElement("polygon", {
  className: "st2",
  points: "215.59,524.09 215.59,530.89 221.79,534.49 221.79,527.69  "
}), React.createElement("polygon", {
  className: "st2",
  points: "221.79,527.69 221.79,534.49 227.79,538.09 227.79,531.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "194.19,504.49 390.99,161.09 385.59,158.09 185.59,506.69 215.59,524.09 215.59,516.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "227.79,523.89 227.79,531.09 309.19,578.09 315.39,574.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "431.59,641.49 327.79,581.69 321.59,585.29 428.39,646.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "315.39,574.49 309.19,578.09 315.39,581.69 321.59,578.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "327.79,581.69 321.59,578.09 315.39,581.69 321.59,585.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "215.59,516.89 215.59,524.09 221.79,527.69 221.79,520.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "221.79,520.49 221.79,527.69 227.79,531.09 227.79,523.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "285.39,606.09 278.79,609.89 278.79,620.29 313.59,640.29 313.59,622.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "278.79,602.29 278.79,602.69 279.19,602.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "279.19,602.49 278.79,602.69 278.79,609.89 285.39,606.09  "
}), React.createElement("path", {
  className: "st2",
  d: "M272.79,593.09c0-0.8,0.8-1.2,1.4-0.8l5.2,3l6.2-3.6l-8.2-4.8c-2.4-1.4-5-1.4-7.4,0c-1.8,1.2-3.4,4-3.4,6.2 v9.6l6.2-3.6C272.79,599.09,272.79,593.09,272.79,593.09z"
}), React.createElement("polygon", {
  className: "st2",
  points: "269.79,615.09 272.79,616.69 272.79,613.29  "
}), React.createElement("path", {
  className: "st2",
  d: "M321.39,612.49l-23.6-13.6l-6.2,3.6l26.6,15.4c0.8,0.4,1.4,1.6,1.4,2.6v23.4l6.2,3.6v-27.2 C325.99,617.09,323.99,614.09,321.39,612.49z"
}), React.createElement("polygon", {
  className: "st2",
  points: "285.59,598.89 291.59,595.29 285.59,591.69 279.39,595.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "272.79,606.29 272.79,599.09 266.59,602.69 266.59,609.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "269.79,615.09 272.79,613.29 272.79,606.29 266.59,609.89 266.59,613.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "297.79,598.89 291.59,595.29 285.59,598.89 291.59,602.49  "
}), React.createElement("path", {
  className: "st2",
  d: "M274.19,592.29c-0.6-0.4-1.4,0-1.4,0.8v6l6.6-3.8L274.19,592.29z"
}), React.createElement("path", {
  className: "st2",
  d: "M318.19,617.89l-26.6-15.4l-6.2,3.6l28.2,16.2v18.2l6,3.6v-23.4C319.79,619.49,318.99,618.29,318.19,617.89z"
}), React.createElement("polygon", {
  className: "st2",
  points: "272.79,613.29 272.79,616.69 278.79,620.29 278.79,609.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "278.79,602.29 279.19,602.49 285.59,598.89 279.39,595.29 272.79,599.09 272.79,606.29 278.79,602.69  "
}), React.createElement("polygon", {
  className: "st2",
  points: "278.79,609.89 278.79,602.69 272.79,606.29 272.79,613.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "285.39,606.09 291.59,602.49 285.59,598.89 279.19,602.49  "
}), React.createElement("path", {
  className: "st2",
  d: "M367.39,140.29l16,9.2l1.6-3c0.6-0.8,1.6-1.2,2.4-1.8l-16.8-9.8c-3-1.8-6.8-0.6-8.6,2.2 c-1.8,3-0.6,6.6,2.4,8.4l15.8,9.2l3.2-5.2L367.39,140.29z"
}), React.createElement("polygon", {
  className: "st2",
  points: "627.79,299.09 630.19,295.09 392.79,158.09 390.99,161.09 578.79,270.69  "
}), React.createElement("path", {
  className: "st2",
  d: "M383.39,149.49l5.4,3.2l1.8-3l242.8,140l1.4-2.4l-247.4-142.6c-0.8,0.6-1.8,1-2.4,1.8L383.39,149.49z"
}), React.createElement("polygon", {
  className: "st2",
  points: "388.59,152.69 383.39,149.49 380.19,154.89 385.59,158.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "392.79,158.09 630.19,295.09 630.99,293.69 581.79,265.29 388.59,152.69 385.59,158.09 390.99,161.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "633.2,289.69 390.39,149.69 388.79,152.69 631.4,292.69  "
}), React.createElement("polygon", {
  className: "st2",
  points: "367.39,140.29 383.39,149.49 383.39,149.49  "
}), React.createElement("rect", {
  x: 385.99,
  y: 148.09,
  className: "st2",
  width: 0,
  height: 6.2
}), React.createElement("polygon", {
  className: "st2",
  points: "630.99,293.69 631.4,292.69 388.79,152.69 388.59,152.69 581.79,265.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "402.79,691.69 425.79,652.29 425.79,652.29  "
}), React.createElement("polygon", {
  className: "st2",
  points: "449.39,610.29 449.39,610.29 492.19,535.89  "
}), React.createElement("polygon", {
  className: "st2",
  points: "431.19,641.29 443.79,621.09 443.79,621.09  "
}), React.createElement("polygon", {
  className: "st2",
  points: "446.39,615.89 449.6,610.49 449.6,610.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "443.39,621.09 446.39,615.49 446.39,615.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "425.59,652.09 428.59,646.69 428.59,646.69  "
}), React.createElement("polygon", {
  className: "st2",
  points: "428.59,646.89 431.59,641.49 431.59,641.49  "
}), React.createElement("polygon", {
  className: "st2",
  points: "344.99,640.29 344.99,658.29 379.59,678.29 379.59,660.29  "
}), React.createElement("path", {
  className: "st2",
  d: "M387.39,650.69l-44-25.6c-2.2-1.4-5-1.4-7.2-0.2c-2,1.2-3.6,4-3.6,6.2v19.8l6.2,3.6v-23.6c0-1,0.6-1.4,1.4-0.8 l44.2,25.4c0.6,0.4,1.4,1.6,1.4,2.4v23.6l6,3.6v-27C391.79,655.29,389.99,652.29,387.39,650.69z"
}), React.createElement("path", {
  className: "st2",
  d: "M384.39,655.89l-44.2-25.4c-0.8-0.4-1.4-0.2-1.4,0.8v23.6l6,3.6v-18l34.6,20v18l6.2,3.6v-23.6 C385.79,657.49,384.99,656.49,384.39,655.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M116.59,533.69l250.8-437.6l283.2,163.4c0.8-1.4,2-2.4,3.8-2.8c1.6-0.4,3-0.2,4.6,0.6l0,0l-288.4-166.6 c-1.4-0.8-3.2-1-4.8-0.6c-1.6,0.4-3,1.4-3.6,2.8l-251,437.8c-1.8,3-0.6,6.8,2.2,8.4l102,58.8v-7L116.59,533.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "251.19,611.49 227.79,597.89 227.79,605.09 245.19,615.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "325.99,654.69 325.99,661.69 332.59,665.49 332.59,658.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M399.59,697.29L399.59,697.29l-7.8-4.6v7.2l10,5.8c0.8,0.6,2,0.8,3.2,0.8c-1.6,0-3.2-0.6-4.4-1.8 C398.59,702.69,398.19,699.69,399.59,697.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "263.59,618.69 257.39,622.09 266.59,627.49 266.59,620.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M406.59,706.29c0.2,0,0.2-0.2,0.4-0.4c-0.6,0.2-1.2,0.6-2,0.6C405.59,706.49,406.19,706.29,406.59,706.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "251.19,611.49 245.19,615.09 251.39,618.69 257.39,615.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "257.39,615.09 251.39,618.69 257.39,622.09 263.59,618.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "221.79,594.49 215.39,590.89 215.39,597.89 221.79,601.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "227.79,597.89 221.79,594.49 221.79,601.49 227.79,605.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "278.79,634.49 313.59,654.69 313.59,647.49 278.79,627.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "319.79,650.89 319.79,658.09 325.99,661.69 325.99,654.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "272.79,623.89 266.59,620.29 266.59,627.49 272.79,631.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "313.59,654.69 319.79,658.09 319.79,650.89 313.59,647.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "278.79,627.29 272.79,623.89 272.79,631.09 278.79,634.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M650.59,259.69l5.4,3l5.2,3l0,0c1.8-3,0.6-6.6-2.2-8.4c-1.6-0.8-3-1-4.6-0.6 C652.59,257.29,651.4,258.29,650.59,259.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M415.59,694.29l-10.4,6l-5.4-3l0,0c-1.4,2.4-1,5.4,1,7.4c1.2,1.2,2.8,1.8,4.4,1.8c0.8,0,1.4-0.4,2-0.6 c1.4-0.6,2.6-1.4,3.2-2.6L415.59,694.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "642.19,287.89 642.39,287.89 646.99,290.49 661.19,265.69 655.99,262.69 641.59,287.69  "
}), React.createElement("path", {
  className: "st1",
  d: "M437.59,655.69c-0.4,0.2-0.6,0-1,0.2c-0.2,0-0.2,0.4-0.6,0.4c-0.6,0.2-1,0.2-1.6,0.2c-0.2,0-0.2-0.2-0.4-0.2 c-0.4,0-0.6-0.2-1-0.2c-0.6-0.2-1.2-0.2-1.8-0.4l-0.6-0.2l-25.8,44.8l10.4-6L437.59,655.69L437.59,655.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M642.19,287.89l-0.4-0.2l-0.2,0.2C641.79,287.89,641.99,287.69,642.19,287.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M430.79,655.29l0.6,0.2c0.6,0.4,1.2,0.4,1.8,0.4c-0.8-0.2-1.4-0.6-2.2-1L430.79,655.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M434.39,656.49c0.6,0,1,0,1.6-0.2c0.2,0,0.2-0.4,0.6-0.4c-0.8,0.2-1.6,0.6-2.6,0.4 C434.19,656.49,434.19,656.49,434.39,656.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M644.79,293.29l0.4,0.2l1.6-3l-4.6-2.6H642l0,0C644.2,289.09,644.79,291.09,644.79,293.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M433.99,656.29c-0.4,0-0.6-0.2-1-0.2C433.39,656.29,433.59,656.29,433.99,656.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M436.59,655.89c0.4-0.2,0.6,0,1-0.2l0,0l0.6-1C437.59,655.09,437.19,655.69,436.59,655.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M639.99,290.49l5,2.8c0-2.2-0.8-4.2-2.8-5.4l0,0c-0.2-0.2-0.4,0-0.6,0L639.99,290.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M443.79,644.89l-9.4,5.4l-0.6-0.4l-3,5c0.6,0.4,1.4,0.8,2.2,1c0.4,0,0.6,0.2,1,0.2c0.8,0,1.8-0.2,2.6-0.4 c0.6-0.2,1.2-0.8,1.6-1.2L443.79,644.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "551.99,445.49 633.79,302.49 633.2,302.09 551.4,445.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "544.79,456.29 454.79,613.49 455.39,613.69 545.79,456.09 545.79,455.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "548.39,450.29 548.99,450.69 551.99,445.49 551.4,445.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "544.79,456.29 545.79,455.89 545.79,456.09 548.99,450.69 548.39,450.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "448.79,624.09 433.79,650.09 434.39,650.29 449.19,624.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "454.79,613.49 451.79,618.69 452.39,619.09 455.39,613.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "451.79,618.69 448.79,624.09 449.19,624.49 452.39,619.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "551.99,445.49 556.59,448.09 638.59,305.29 633.79,302.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "459.99,616.49 550.59,458.69 545.79,456.09 455.39,613.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "548.99,450.69 553.59,453.29 556.59,448.09 551.99,445.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "545.79,456.09 550.59,458.69 553.59,453.29 548.99,450.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "449.19,624.49 434.39,650.29 443.79,644.89 453.99,627.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "452.39,619.09 456.99,621.89 459.99,616.49 455.39,613.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "452.39,619.09 449.19,624.49 453.99,627.09 456.99,621.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M645.19,293.49l-0.4-0.2c0,0.4,0,0.6,0,1L645.19,293.49z"
}), React.createElement("path", {
  className: "st1",
  d: "M639.2,293.29l4.6,2.8l1-1.6c0-0.4,0-0.6,0-1l-5-2.8l-1.4,2.4L639.2,293.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "637.39,296.29 639.2,293.29 638.59,292.89 636.79,295.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "633.79,302.49 636.99,297.09 636.4,296.89 633.2,302.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "642.19,298.89 643.79,295.89 639.2,293.29 637.39,296.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "638.59,305.29 641.59,299.89 636.99,297.09 633.79,302.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "636.99,297.09 637.39,296.29 636.79,295.89 636.4,296.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "641.59,299.89 642.19,298.89 637.39,296.29 636.99,297.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "344.99,672.69 379.59,692.69 379.59,685.49 344.99,665.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "385.79,689.09 385.79,696.29 391.79,699.69 391.79,692.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "338.79,662.09 332.59,658.29 332.59,665.49 338.79,669.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "344.99,665.49 338.79,662.09 338.79,669.09 344.99,672.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "379.59,692.69 385.79,696.29 385.79,689.09 379.59,685.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "124.99,531.49 369.59,104.49 647.39,264.89 636.19,284.49 636.19,284.49 650.59,259.69 650.59,259.69  367.39,96.09 116.59,533.69 215.39,590.89 215.39,583.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "257.39,607.89 227.79,590.69 227.79,597.89 251.19,611.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "263.59,618.69 266.59,620.29 266.59,616.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "325.99,647.49 325.99,654.69 332.59,658.29 332.59,651.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "391.79,685.49 391.79,692.69 399.79,697.09 402.79,691.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "263.59,611.49 257.39,607.89 251.19,611.49 257.39,615.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "266.59,613.09 263.59,611.49 257.39,615.09 263.59,618.69 266.59,616.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "215.39,583.69 215.39,590.89 221.79,594.49 221.79,587.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "227.79,590.69 221.79,587.29 221.79,594.49 227.79,597.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "627.99,299.09 627.79,299.09 545.59,442.69 545.59,442.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "534.2,462.49 534.2,462.49 492.19,535.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "540.39,451.89 545.59,442.69 545.59,442.69 540.19,451.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "534.2,462.49 540.39,451.89 540.39,451.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "634.59,287.29 636.19,284.29 636.19,284.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "278.79,627.29 313.59,647.49 313.59,640.29 278.79,620.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "269.79,615.09 266.59,616.89 266.59,620.29 272.79,623.89 272.79,616.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "319.79,643.89 319.79,650.89 325.99,654.69 325.99,647.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "266.59,616.89 269.79,615.09 266.59,613.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "313.59,640.29 313.59,647.49 319.79,650.89 319.79,643.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "278.79,620.29 272.79,616.69 272.79,623.89 278.79,627.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "627.79,299.09 629.99,295.29 629.99,295.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "633.2,289.69 634.59,287.49 634.59,287.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "629.99,295.29 630.99,293.69 630.99,293.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "631.59,292.89 633.39,289.69 633.39,289.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "630.99,293.69 631.59,292.69 631.59,292.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "636.19,284.49 641.59,287.69 655.99,262.69 650.59,259.69 650.59,259.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "425.39,652.29 402.79,691.89 402.79,691.69 399.79,697.09 404.99,700.29 430.79,655.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M546.19,442.89l82.2-143.4l-0.6-0.4l-82.4,143.6C545.79,442.69,545.99,442.89,546.19,442.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "535.39,461.89 534.2,462.49 492.19,535.89 449.39,610.29 449.99,610.69 481.19,556.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M546.19,442.89c-0.2,0-0.4-0.2-0.6-0.2l-5.2,9.2l1.2-0.6L546.19,442.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "535.39,461.89 541.4,451.29 540.39,451.89 534.2,462.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "443.39,621.09 431.59,641.69 432.19,641.89 443.99,621.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "449.99,610.69 449.39,610.29 446.39,615.69 446.99,616.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "446.99,616.09 446.39,615.69 443.39,621.09 443.99,621.29  "
}), React.createElement("path", {
  className: "st1",
  d: "M636.19,288.29c0.6-0.4,0.8-1,1.4-1c1.2-0.4,2.6,0,3.8,0.6l0.2-0.2l-5.4-3l-1.6,3L636.19,288.29z"
}), React.createElement("path", {
  className: "st1",
  d: "M430.19,654.69c-2-2-2.4-5-1-7.4l-0.6-0.4l-3,5.4l5.4,3l0.2-0.2C430.59,654.89,430.39,654.89,430.19,654.69z"
}), React.createElement("polygon", {
  className: "st1",
  points: "628.59,299.49 628.39,299.49 546.19,442.89 546.19,442.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "535.39,461.89 535.39,461.89 481.19,556.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "541.4,451.29 546.19,442.89 546.19,442.89  "
}), React.createElement("rect", {
  x: 538.39,
  y: 450.49,
  className: "st1",
  width: 0,
  height: 12.2
}), React.createElement("polygon", {
  className: "st1",
  points: "432.19,641.89 431.59,641.69 428.59,646.89 428.99,647.29 428.99,647.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "481.19,556.29 449.99,610.69 449.99,610.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "431.99,641.69 444.39,621.49 444.39,621.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "446.99,616.09 449.99,610.69 449.99,610.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "443.99,621.29 446.99,615.89 446.99,615.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M641.59,287.89c-1.2-0.6-2.6-1-3.8-0.6c-0.6,0.2-1,0.8-1.4,1l3.8,2.2L641.59,287.89z"
}), React.createElement("path", {
  className: "st1",
  d: "M430.19,654.69c0.2,0.2,0.6,0.2,0.8,0.4l3-5l-4.8-2.8C427.59,649.69,428.19,652.69,430.19,654.69z"
}), React.createElement("path", {
  className: "st1",
  d: "M548.59,443.49l2.8,1.6l82-142.8l-4.8-2.8l-82.2,143.4C547.19,442.89,547.99,443.09,548.59,443.49z"
}), React.createElement("polygon", {
  className: "st1",
  points: "481.19,556.29 449.99,610.69 454.79,613.49 544.79,456.29 535.39,461.89  "
}), React.createElement("path", {
  className: "st1",
  d: "M548.39,450.29l3-5.2l-2.8-1.6c-0.6-0.4-1.6-0.6-2.4-0.6l-4.8,8.4l4.2-2.4L548.39,450.29z"
}), React.createElement("polygon", {
  className: "st1",
  points: "544.79,456.29 548.39,450.29 545.79,448.69 541.4,451.29 535.39,461.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "443.99,621.29 432.19,641.89 432.19,641.89 428.99,647.29 428.99,647.29 433.79,650.09 448.79,624.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "449.99,610.69 446.99,616.09 451.79,618.69 454.79,613.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "446.99,616.09 443.99,621.29 448.79,624.09 451.79,618.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "630.79,295.49 630.19,295.29 627.99,299.09 628.39,299.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M633.99,290.09c0.6-0.8,1.4-1.2,2.4-1.8l-1.6-1l-1.4,2.4L633.99,290.09z"
}), React.createElement("polygon", {
  className: "st1",
  points: "632.19,293.09 633.79,290.09 633.99,290.09 633.2,289.69 631.59,292.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "628.39,299.49 628.59,299.49 631.59,294.09 630.99,293.69 630.19,295.29 630.79,295.49  "
}), React.createElement("path", {
  className: "st1",
  d: "M638.59,292.89l1.4-2.4l-3.8-2.2c-0.8,0.6-1.8,1-2.4,1.8L638.59,292.89z"
}), React.createElement("polygon", {
  className: "st1",
  points: "633.2,302.09 636.4,296.89 631.59,294.09 628.59,299.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "632.19,293.09 636.79,295.89 638.59,292.89 633.99,290.09 633.79,290.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "631.59,294.09 632.19,293.09 631.59,292.89 630.99,293.69  "
}), React.createElement("polygon", {
  className: "st1",
  points: "636.4,296.89 636.79,295.89 632.19,293.09 631.59,294.09  "
}), React.createElement("polygon", {
  className: "st1",
  points: "344.99,665.49 379.59,685.49 379.59,678.29 344.99,658.29  "
}), React.createElement("polygon", {
  className: "st1",
  points: "385.79,681.89 385.79,689.09 391.79,692.69 391.79,685.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "332.59,651.29 332.59,658.29 338.79,662.09 338.79,654.89  "
}), React.createElement("polygon", {
  className: "st1",
  points: "344.99,658.29 338.79,654.89 338.79,662.09 344.99,665.49  "
}), React.createElement("polygon", {
  className: "st1",
  points: "379.59,678.29 379.59,685.49 385.79,689.09 385.79,681.89  "
}));

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Home_Icon.f100d0fd.svg";
export { ForwardRef as ReactComponent };